Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.SocialContentFacebookMediaView extends Backbone.View
  template: JST["backbone/templates/monitoring/social_contents_v2/social_content_facebook_media"]
  className: 'sc-media'

  initialize: (options = {}) ->
    @picture = options.picture
    @video = options.video

  render: ->
    @$el.html @template
      video: @video
      picture: @picture
    @
